interface StepHeaderProps {
  title: string;
  subTitle: string;
  stepNumber: number;
}

const StepHeader: React.FC<StepHeaderProps> = ({
  title,
  subTitle,
  stepNumber,
}) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <span className="text-gray-900 alpha-display-1">
        {stepNumber}. {title}
      </span>
      <span className="text-center text-gray-800 alpha-body-1">{subTitle}</span>
    </div>
  );
};

export { StepHeader };
